import { gql } from "@apollo/client";

export const PARAMETER = gql`
    query queryParameter($key: String!) {
        parameter(key: $key) {
            id
            name
            key
            value
            is_deleted
        }
    }
`;

export const PARAMETERS = gql`
    query queryParameters {
        parameters {
            id
            name
            key
            value
            is_deleted
        }
    }
`;

export default PARAMETER;
